import { render, staticRenderFns } from "./CarDetailsModal.vue?vue&type=template&id=2a067e0e&scoped=true&"
import script from "./CarDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CarDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./CarDetailsModal.vue?vue&type=style&index=0&id=2a067e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a067e0e",
  null
  
)

export default component.exports